// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { Media } from '../../types/keepeekType';
import type { EmbeddedUrl } from '../../types/embeddedUrlTypes';

type Props = {
  medias?: Media[],
  embeddedUrls?: EmbeddedUrl[],
}

type IframeElement = {
  title: string,
  link: string,
  showButton: boolean,
}

function KeepeekMediaVirtualVisit({ medias, embeddedUrls }: Props) {
  const mapMediaToIframeElement = (media: Media): IframeElement => ({
    title: media.title,
    link: `https://cdn.pannellum.org/2.5/pannellum.htm#panorama=${media.fullscreen}&autoLoad=true`,
  });

  const mapEmbeddedToIFrameElement = (embedded: EmbeddedUrl): IframeElement => ({
    title: embedded.tabTitle,
    link: embedded.iframeLink,
    showButton: true,
  });

  const mapToIframe = (iframe: IframeElement) => (
    <>
      <div className="media-title">{iframe.title}</div>
      <iframe
        title={iframe.title}
        width="1200"
        height="600"
        allowFullScreen
        src={iframe.link}
      />
      {
        iframe.showButton && (
          <div
            className="apollo-button-contained visit-link-button"
          >
            <a target="_blank" href={iframe.link} rel="noopener noreferrer">
              <i className="fa fa-external-link" />
              <Translate value="mallData.MEDIA.REDIRECT" />
            </a>
          </div>
        )
      }
      <div className="media-separator" />
    </>
  );

  return (
    <div className="marketing-media-container virtual-visits">
      {
        !!medias && medias
          .sort((a, b) => a.order - b.order)
          .map(mapMediaToIframeElement)
          .map(mapToIframe)
      }
      {
        !!embeddedUrls && embeddedUrls
          .sort((a, b) => a.order - b.order)
          .map(mapEmbeddedToIFrameElement)
          .map(mapToIframe)
      }
    </div>
  );
}

export default KeepeekMediaVirtualVisit;
